import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { CustomerFlag } from '@/api/types';

export function useCustomerFlags(userId?: string) {
  return useQuery({
    queryKey: ['customerFlags', userId],
    queryFn: () => apiClient<CustomerFlag[]>(`/admin/customers/${userId}/flags`),
    enabled: !!userId,
  });
}

export function useAddCustomerFlag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, flagType, reason }: { userId: string; flagType: string; reason: string }) =>
      apiClient<CustomerFlag>(`/admin/customers/${userId}/flags`, {
        method: 'POST',
        body: JSON.stringify({ flagType, reason }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['customerFlags'] });
    },
  });
}

export function useRemoveCustomerFlag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (flagId: string) =>
      apiClient<void>(`/admin/customers/flags/${flagId}`, { method: 'DELETE' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['customerFlags'] });
    },
  });
}
